import { Pipe, PipeTransform } from '@angular/core';

export type SortOrder = 'asc' | 'desc';

@Pipe({ name: 'sort' })
export class SortPipe implements PipeTransform {
  transform<T>(value: T[], sortOrder: SortOrder = 'asc', sortKey: keyof T, firstValue?: string): T[] {
    const firstValueLowerCase = firstValue?.toLowerCase();

    return [...value].sort((a, b) => {
      const aValue = (a[sortKey] + '').toLowerCase();
      const bValue = (b[sortKey] + '').toLowerCase();

      if (firstValueLowerCase) {
        if (firstValueLowerCase === aValue) return -1;
        if (firstValueLowerCase === bValue) return 1;
      }

      const sort = aValue.localeCompare(bValue, undefined, {
        numeric: true,
        sensitivity: 'base',
      });

      return sortOrder === 'asc' ? sort : -sort;
    });
  }
}
